import { IconGoogle24 as Google } from 'src/shared/components/icon-google-24/icon-google-24.js';

export const Icons: Record<string, (props: React.SVGAttributes<SVGSVGElement>) => React.JSX.Element> = {
    google: Google,
};
